import { TextField } from '@mui/material';
import React, { ChangeEvent, useState } from 'react';
import { ArticleEditAction, actions } from '../../reducer';
import { SLUG_LABEL } from '../constants';
import { validateSlug } from '../../../../utils/slugValidation';

interface SlugInputProps {
  dispatch: React.Dispatch<ArticleEditAction>;
  slug?: string | null;
}

export const SlugInput: React.FC<SlugInputProps> = ({ dispatch, slug }) => {
  const [error, setError] = useState<string>('');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value.toLowerCase(); // Convert to lowercase to match backend validation
    const validationError = validateSlug(value);
    setError(validationError);

    dispatch(
      actions.updateField({
        field: 'slug',
        value,
      }),
    );
  };

  return (
    <TextField
      InputLabelProps={{
        shrink: true,
      }}
      label={SLUG_LABEL}
      multiline
      onChange={handleChange}
      value={slug || ''}
      variant="standard"
      error={!!error}
      helperText={error}
    />
  );
};
